export default "__VITE_PUBLIC_ASSET__fcef7e29__"